import cx from "classnames";
import * as React from "react";

interface QESWidgetContentProps {
  className?: string;
}

/**
 * The base body of the Widget. Meant to be rendered in the "middle" of the widget, between the Header and Footer.
 */
export const QESWidgetContent: React.FC<React.PropsWithChildren<QESWidgetContentProps>> = ({
  children,
  className,
}) => {
  return (
    <div className={cx("qes-widget__content", className)}>
      {children}
    </div>
  );
};
